module.exports = __webpack_public_path__ + "img/active-layer1.f10ee0c0.png";